import { useRef, useState } from 'react'

import { AccordionAnimatedContent } from '../../Accordion'
import { FormFieldsContainer } from '../FormFieldsContainer'

import { ToggleVisibilityButton } from './ToggleVisibilityButton'

import * as styles from './FormAdditionalFields.module.css'

function FormAdditionalFields({ children, toggleVisibilityProps }) {
  const [isAdditionalFieldsVisible, setAdditionalFieldsVisible] =
    useState(false)

  const ref = useRef(null)

  function handleToggleFieldsVisibility() {
    setAdditionalFieldsVisible(prevVisibility => !prevVisibility)
  }

  function scrollIntoView() {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <div>
      <ToggleVisibilityButton
        {...toggleVisibilityProps}
        isOpen={isAdditionalFieldsVisible}
        onClick={handleToggleFieldsVisibility}
      />
      <AccordionAnimatedContent
        isOpen={isAdditionalFieldsVisible}
        ref={ref}
        onTransitionEnd={scrollIntoView}
      >
        <FormFieldsContainer className={styles.fieldsContainer}>
          {children}
        </FormFieldsContainer>
      </AccordionAnimatedContent>
    </div>
  )
}

export default FormAdditionalFields
